//Defaults
const defaultsCartPage = {
  cartPageLoop: ".cart-page-loop", // classname
  removeFromCartPage: ".cp-remove-btn", //classname
  cartPageCounter: "#cart-page-counter", // classname

  addLineItemCartPage: ".cp-add-btn", //classname
  removeLineItemCartPage: ".cp-subtract-btn", //classname
};

const cartPageLoop = document.querySelector(defaultsCartPage.cartPageLoop);
let removeFromCartPage = document.querySelectorAll(defaultsCartPage.removeFromCartPage);

let addLineItemCartPage = document.querySelectorAll(defaultsCartPage.addLineItemCartPage);
let removeLineItemCartPage = document.querySelectorAll(defaultsCartPage.removeLineItemCartPage);
const cartPageCounter = document.querySelector(defaultsCartPage.cartPageCounter);
//const htmlSelector = document.documentElement;

//Title Case
function titleCase(str) {
  str = str.toLowerCase().split(" ");
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(" ");
}

//Clear Cart Page
const clearCartPage = function () {
  cartPageLoop.innerHTML = "";
};

//Display Cart in Side Cart
const displayCartPage = function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      //onCartUpdate(cart);

      if (cart.item_count === 0) {
        //console.log('Cart page is empty');
        updateSubtotal();
        updateSubtotalCartPage();
      } else {
        renderCart(cart);
        updateSubtotal();

        renderCartPage(cart);
        updateSubtotalCartPage();
        //console.log('Cart page has items');
      }

      let cartItems = cart.items;
      let giftStatus = false;

      cartItems.forEach(function (item, i) {
        if (item.id == 40412251127891) {
          //document.querySelector('.bottom .gift').classList.add('hide');
          giftStatus = true;
          //console.log("Gift true");
        }
      });

      if (giftStatus) {
        document.querySelector(".gift-three").classList.add("hide");
          //console.log("Gift true two");
      } else {
        document.querySelector(".gift-three").classList.remove("hide");
          //console.log("Gift false");
      }

    },
  });
};

//Remove Product From Cart
const removeProductFromCartPageCounter = function () {
  cartPageCounter.innerHTML = Number(cartPageCounter.innerHTML) - 1;
};

//Change Quantity
const changeItemCartPage = function (line, callback) {
  const quantity = 0;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("fetcher");
        //onCartUpdate(cart);
        clearCartPage();
        displayCartPage();
        updateSubtotalCartPage();
        cartPageCounter.innerHTML = cart.item_count;
      }
    },
  });
};

//Add One Item
const addOneItemCartPage = function (line, qty, location) {
  let addNewQty = qty + 1;
  const newQty = qty + 1;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + newQty + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("Adder");
        //onCartUpdate(cart);
        //clearCartPage();
        //displayCartPage();
        updateSubtotalCartPage();
        document.querySelectorAll(".cart-page-loop li")[location].dataset.qty = addNewQty;
        renderQuantitiesCartPage(cart, location);
        cartPageCounter.innerHTML = cart.item_count;
      }
    },
  });
};

//Remove One Item
const subtractOneItemCartPage = function (line, qty, location) {
  let subNewQty = qty - 1;
  const newQty = qty - 1;
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + newQty + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        //console.log("Callback");
        callback(cart);
      } else {
        //console.log("Remover");
        //onCartUpdate(cart);
        // clearCartPage();
        // displayCartPage();
        updateSubtotalCartPage();
        document.querySelectorAll(".cart-page-loop li")[location].dataset.qty = subNewQty;
        renderQuantitiesCartPage(cart, location);
        cartPageCounter.innerHTML = cart.item_count;
      }
    },
  });
};

//Render Cart
const renderCartPage = function (cart) {
  cart.items.forEach(function (item, index) {
    //cartPageCounter.innerHTML = cart.item_count;
    //console.log(item + " is in cart page");
    let dirtyHandle = item.handle;
    let dirtyImg = item.image;
    let splitImg = dirtyImg.split(".jpg");
    let largeImg = splitImg[0] + "_720x.jpg" + splitImg[1];
    //let largeImg = dirtyImg;
    //console.log(largeImg);
    let pImage = '<a href="' + item.url + '"><img src="' + largeImg + '"/></a>';

    //let pImage = '<a href="'+ item.url + '"><img src="' + item.image + '"/></a>';

    let pTitle = '<p class="cp-title"><a href="' + item.url + '">' + item.product_title + "</a></p>";

    let dirtyPrice = item.line_price;
    let roundedPrice = dirtyPrice / 100;
    let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    let pPrice = '<p class="cp-price">$' + formatPrice + "</p>";

    let pQuantity = '<p class="cp-quantity">Quantity: <a class="cp-subtract-btn">-</a><span>' + item.quantity + '</span><a class="cp-add-btn">+</a></p>';
    let pRemove = '<a class="cp-remove-btn" href="#">Remove</a>';

    //let pRemove = '<p>' + defaults.removeFromCartNoDot + '</p>';
    let pInfo =
      '<li class="item" data-line="' +
      Number(index + 1) +
      '" data-qty="' +
      item.quantity +
      '">' +
      '<div class="left">' +
      pImage +
      "</div>" +
      '<div class="right">' +
      pTitle +
      pPrice +
      '<div class="cp-variants"></div>' +
      pQuantity +
      '<p class="cp-tags"></p>' +
      pRemove +
      '</div><div class="clear"></div></li>';

    cartPageLoop.innerHTML = cartPageLoop.innerHTML + pInfo;

    //console.log(item.options_with_values);

    let allVariants = item.options_with_values;
    let variantsWrap = document.querySelectorAll(".cp-variants")[index];

    allVariants.forEach(function (tag, j) {
      //console.log(tag.name + ' ' + tag.value);

      let cleanTagName = titleCase(tag.name);
      let cleanValueName = titleCase(tag.value);

      if (cleanTagName == "Title") {
        variantsWrap.classList.add("remove-item");
      } else {
        let singleVariant = "<p>" + cleanTagName + ": " + cleanValueName + "</p>";
        variantsWrap.innerHTML = variantsWrap.innerHTML + singleVariant;
      }
    });

    //Availability
    let dirtyName = "/products/" + item.handle + ".js";
    let jackpotId = item.variant_id;

    jQuery.getJSON(dirtyName, function (product) {
      let varList = product.variants;
      varList.forEach(function (jtem) {
        //console.log(jtem);
        if (jackpotId == jtem.id) {
          let currentAvail = String(jtem.inventory_policy);
          let currentInventoryString = jtem.inventory_quantity;
          let currentInventory = parseInt(currentInventoryString);

          //console.log(jtem.name + ' has ' + currentInventory + " available. Status is " + currentAvail);

          let cpTags = document.querySelectorAll(".cp-tags");
          if (dirtyHandle != "gift-card") {
            if (currentInventory > 0) {
              if (cpTags[index]) {
                if (product.handle == "gift-wrapping") {
                  cpTags[index].innerHTML = "";
                } else {
                  //cpTags[index].innerHTML = "Availability: In stock.  Ships in 1-2 weeks.";
                  cpTags[index].innerHTML = "Availability: In stock";
                }
              }
            } else {
              if (cpTags[index]) {
                let eightTwelve = [
                  "onyx-dream-collar",
                  "coquille-hand-mirror-in-lapis",
                  "coquille-hand-mirror-in-onyx",
                  "nautilus-pill-box-in-onyx",
                  "coquille-paperweight",
                  "onyx-coquille-box",
                  "quartz-coquille-box",
                  "onyx-pyramid-cuff",
                  "quartz-pyramid-cuff",
                  "onyx-division-ring",
                  "onyx-dream-collar",
                  "onyx-crevice-pendant",
                  "large-coquille-pendant",
                  "lapis-division-collar",
                  "lapis-division-ring",
                  "lapis-donut-ring",
                  "small-coquille-pendant",
                  "quartz-division-ring",
                  "quartz-dream-collar",
                  "quartz-crevice-pendant",
                  "jade-division-ring",
                  "jade-division-collar",
                  "donut-ring",
                  "onyx-donut-ring",
                  "cyclops-lighter-case-in-onyx",
                  "one-eye-lighter-case-in-moonstone",
                  "pyramid-pill-box-citrine",
                  "four-eyes-small-votive",
                  "four-eyes-votive",
                  "one-eye-lighter-case-in-jade",
                  "jade-vienna-collar",
                  "evening-flask",
                  "rising-moon-flask",
                  "dusk-lighter-case",
                  "midnight-lighter-case",
                  "small-moon-pendant-in-onyx",
                  "long-dripping-stone-earrings-in-carnelian",
                  "medium-moon-pendant-in-carnelian",
                  "small-moon-pendant-in-carnelian",
                  "dripping-stone-earrings-in-carnelian",
                  "large-moon-pendant-in-onyx",
                  "medium-moon-pendant-in-onyx",
                  "dawn-lighter-case",
                  "pyramid-ring-in-onyx",
                  "tilde-ring",
                  "teardrop-pouch",
                  "long-teardrop-pouch",
                  "large-carnelian-pendant",
                  "medium-onyx-donut-ring",
                  "medium-jade-donut-ring",
                  "onyx-bagel-ear-cuff",

                  "vienna-collar-in-carnelian",
                  "onyx-donut-ring",
                  "large-spear-pendant-in-onyx",
                  "eclipse-lighter-case",
                  "twilight-lighter-case",
                  "large-spear-pendant",

                  "pearl-moon-ring",

                  "medium-angelika-earrings-in-jade",

                  "verona-comb",

                  "large-full-moon-pendant-in-quartz",
                  "egg-pendant-in-onyx",
                  "spear-earrings-in-quartz",
                  "large-spear-pendant-in-quartz",
                  "everyday-egg-pendant-in-onyx",
                  "small-full-moon-pendant-in-quartz",
                  "medium-full-moon-pendant-in-quartz",
                  "everyday-egg-choker-in-onyx",

                  "jade-bagel-ear-cuff",

                  "rinba-cuff",
                  "barbara-cuff",

                  "small-angelyne-earrings-in-onyx",

                  "dripping-stone-earrings-in-onyx",
                  "long-dripping-stone-earrings-in-onyx",

                  "jasper-division-ring",

                  "large-full-moon-pendant-in-jade",
                  "small-full-moon-pendant-in-jade",
                  "medium-full-moon-pendant-in-jade",
                  "egg-pendant-in-jade",
                  "everyday-egg-pendant-in-jade",
                  "everyday-egg-choker-in-jade",
                  "tiny-egg-pendant-in-jade",
                  "egg-choker-in-jade",

                  "cyclops-lighter-case-in-jade",
                  "cyclops-lighter-case-in-mother-of-pearl",
                  "nautilus-cigarette-case-sapphire",
                  "turin-comb",

                  "carnelian-moon-ring",

                  ,
                  "chandelier-choker-in-onyx",
                  "chandelier-earrings-in-onyx",
                  "cleo-tassel-earrings",

                  "crystal-ball-1",
                  "perfume-vial-onyx-jade",
                  "perfume-vial-onyx-quartz",
                  "quartz-amulet-collar-onyx",
                  "quartz-amulet-collar-sterling-silver",
                  "anais-choker-1",
                  "large-spear-pendant-in-quartz",
                  "large-hiera-ring",
                  "onyx-pyramid-cuff",
                  "quartz-pyramid-cuff",
                  "pearl-moon-ring"
                ];

                let threeFour = [
                  "droplet-earrings-in-onyx",
                  "dripping-stone-earrings-in-vegetable-ivory",
                  "everyday-boule-earrings-tigers-eye",
                  "jasper-boule-collar",
                  "medium-chalcedony-collar",
                  "neue-pearl-earrings-in-jasper",
                  "neue-pearl-earrings-in-lapis",
                  "neue-pearl-earrings-in-onyx",
                  "quartz-donut-hoops",
                  "spear-earrings-in-carnelian",
                  "tigers-eye-donut-hoops",
                  "white-jade-donut-hoops",
                ];

                let preOrder = "";

                if (eightTwelve.includes(product.handle)) {
                  cpTags[index].innerHTML =
                    "Availability: Made To Order. Ships in 8-12 weeks.";
                } else if (threeFour.includes(product.handle)) {
                  cpTags[index].innerHTML =
                    "Availability: Made To Order. Ships in 3-4 weeks.";
                } else if (preOrder.includes(product.handle)) {
                  cpTags[index].innerHTML =
                    "Order by July 19th for delivery by October 15th";
                  addCustomPropertyToCartItem(
                    jackpotId,
                    "Order by July 19th for delivery by October 15th",
                  );
                } else {
                  cpTags[index].innerHTML =
                    "Availability: Made To Order. Ships in 6-8 weeks.";
                }
              }
            }
          }
        }
      });
    });

    //Availability
    // let dirtyName = '/products/' + item.handle + '.js';
    // let jackpotId = item.variant_id;

    // jQuery.getJSON(dirtyName, function(product) {
    //   let varList = product.variants;
    //   varList.forEach(function(jtem){
    //     if(jackpotId == jtem.id){
    //       let currentAvail = String(jtem.inventory_policy);
    //       //console.log(currentAvail);
    //       if(currentAvail === 'continue'){
    //         document.querySelectorAll('.cp-tags')[index].innerHTML = "Availability: Made to order";
    //       } else {
    //         document.querySelectorAll('.cp-tags')[index].innerHTML = "Availability: In stock";
    //       }
    //     }
    //   });
    // });
  });

  //Remove
  document.querySelectorAll(".cp-remove-btn").forEach((element) => {
    element.addEventListener("click", function () {
      const lineID = this.parentNode.getAttribute("data-line");
      //console.log('cartpage - aa');
    });
  });

  removeFromCartPage = document.querySelectorAll(defaultsCartPage.removeFromCartPage);

  for (let i = 0; i < removeFromCartPage.length; i++) {
    removeFromCartPage[i].addEventListener("click", function (event) {
      event.preventDefault();
      const line = this.parentNode.parentNode.getAttribute("data-line");
      //console.log(line);
      changeItemCartPage(line);
    });
  }

  let divClear = document.createElement("div");
  divClear.classList.add("clear");
  cartPageLoop.append(divClear);

  //Add
  addLineItemCartPage = document.querySelectorAll(defaultsCartPage.addLineItemCartPage);

  for (let i = 0; i < addLineItemCartPage.length; i++) {
    addLineItemCartPage[i].addEventListener("click", function () {
      let linez = this.parentNode.parentNode.parentNode.getAttribute("data-line");
      let lineQTY = parseInt(this.parentNode.parentNode.parentNode.getAttribute("data-qty"));
      let currentIndexer = i;
      //console.log(linez + lineQTY);
      addOneItemCartPage(linez, lineQTY, currentIndexer);
    });
  }

  //Remove
  removeLineItemCartPage = document.querySelectorAll(defaultsCartPage.removeLineItemCartPage);

  for (let i = 0; i < addLineItemCartPage.length; i++) {
    removeLineItemCartPage[i].addEventListener("click", function () {
      let linez = this.parentNode.parentNode.parentNode.getAttribute("data-line");
      let lineQTY = parseInt(this.parentNode.parentNode.parentNode.getAttribute("data-qty"));
      let currentIndexer = i;

      if (lineQTY == 1) {
        changeItemCartPage(linez, currentIndexer);
      } else {
        //subtractOneItem(linez, lineQTY, currentIndexer);
        subtractOneItemCartPage(linez, lineQTY, currentIndexer);
      }

      //console.log(linez + lineQTY);
    });
  }
};

const renderQuantitiesCartPage = function (cart, selecter) {
  cart.items.forEach(function (item, index) {
    if (selecter == index) {
      //console.log(item);
      let dirtyPrice = item.line_price;
      let roundedPrice = dirtyPrice / 100;
      let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      document.querySelectorAll(".cp-price")[index].innerHTML = "$ " + formatPrice;
      document.querySelectorAll(".cp-quantity span")[index].innerHTML = item.quantity;
    }
  });
};

const updateSubtotalCartPage = function () {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      //onCartUpdate(cart);

      document.querySelector("#cart-counter").innerHTML = cart.item_count;

      if (cart.item_count === 0) {
        document.querySelector("#cart-page-subtotal").innerHTML = "$ 0.00";
        document.querySelector("#cart-page-total").innerHTML = "$ 0.00";
        //document.querySelector('#side-cart').classList.add('empty');
      } else {
        let dirtyPrice = cart.items_subtotal_price;
        let roundedPrice = dirtyPrice / 100;
        let formatPrice = roundedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        document.querySelector("#side-cart-subtotal").innerHTML = "$ " + formatPrice;
        document.querySelector("#cp-sticky-bottom").innerHTML = "$ " + formatPrice;
        document.querySelector("#cart-page-subtotal").innerHTML = "$ " + formatPrice;
        document.querySelector("#cart-page-total").innerHTML = "$ " + formatPrice;
      }
    },
  });
};

//displayCartPage();

/*
$("#add-to-cart-gift-three").click(function () {
  addItemToCartThree(40412251127891, 1);
});

function addItemToCartThree(variant_id, qty) {
  data = {
    id: variant_id,
    quantity: qty,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      $("#add-to-cart-gift").addClass('checked');
      clearCartPage();
      displayCartPage();
    },
  });
}
*/